<ion-header class="modal-header">
  <div class="modal-title">
    <h3>{{ id ? 'Edit Ticket Type' : 'Add Ticket Type' }}</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="padding: 16px">
    <ion-label class="input-label"> Name </ion-label>
    <ion-input #nameInput placeholder="e.g. IT Support Request" [(ngModel)]="name" class="input-field"> </ion-input>
    <ion-label class="input-label">
      Description (private)
      <ion-icon
        name="information-circle"
        class="icon-padded-left"
        ngxTippy
        data-tippy-content="Add a helpful description to be used internally or by the AI to automatically select this ticket type from a user's query. This is not visible to end users."
      ></ion-icon>
    </ion-label>
    <ion-textarea
      #descriptionInput
      placeholder="e.g. Issues related to information technology and hardware"
      [(ngModel)]="description"
      class="input-field"
      rows="3"
      [autoGrow]="true"
    >
    </ion-textarea>
    <ion-label class="input-label">
      User-provided Priority field
      <ion-icon
        name="information-circle"
        class="icon-padded-left"
        ngxTippy
        data-tippy-content="Option for the user to provide a priority level"
      ></ion-icon>
    </ion-label>
    <ion-select
      [(ngModel)]="prioritySelector"
      interface="popover"
      placeholder="Ticket priority selector"
      aria-label="Ticket priority selector"
      class="select-outline input-field"
    >
      <ion-select-option [value]="0"> Disabled </ion-select-option>
      <ion-select-option [value]="1"> Optional </ion-select-option>
      <ion-select-option [value]="2"> Required </ion-select-option>
    </ion-select>
    <ion-label class="input-label"> Input Fields </ion-label>
    <div style="margin: 0 -10px">
      <app-custom-fields
        *ngIf="fields"
        [customFields]="fields"
        [placeholder]="'Ex: Favorite color'"
        [addCustomFieldButtonLabel]="'Add a custom ticket field'"
        [showPublicOption]="true"
        [showUserAttributeOption]="false"
        [showBranchingInput]="true"
        [showDescription]="true"
        contextPrefix="conversation.ticketTypeFields"
      >
      </app-custom-fields>
    </div>

    <h2 class="input-section-header">
      <strong>(Advanced) Bot Configuration</strong>
    </h2>
    <div class="input-section-divider"></div>
    <div>
      <ng-container *ngIf="showTopicInstructionField">
        <div class="input-section">
          <ion-label class="input-label">
            Additional AI Prompt Instructions
            <ion-icon
              name="information-circle"
              class="icon-padded-left"
              ngxTippy
              data-tippy-content="Additional prompt instructions for the model regarding this topic. These instructions will be used in key parts of the agent. (i.e., when to escalate, how to respond, reactions to specific keywords)"
            ></ion-icon>
          </ion-label>
          <div class="input-field">
            <ion-textarea
              [(ngModel)]="instructions"
              style="margin-top: 0"
              rows="3"
              placeholder="e.g. If the user asks for a new laptop, respond with 'I've created a ticket for you. It will be delivered to your desk tomorrow.'"
              [autoGrow]="true"
            ></ion-textarea>
            <ion-button
              [ngClass]="{
                isSuggestingInstruction: isSuggestingInstruction
              }"
              (click)="suggestTopicInstruction()"
              [hidden]="instructions?.length"
              class="btn-small"
              [disabled]="isSuggestingInstruction"
              style="margin: 8px"
            >
              ✨ Suggest sample instructions
              <span class="ai-magic-overlay linear-gradient-subtle-animated"></span>
            </ion-button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isDev">
        <ion-label class="input-label"> Tools </ion-label>
        <ion-card *ngFor="let tool of tools; let i = index; trackBy: arrayTrackBy">
          <ion-card-header class="flex-space-between" style="margin-bottom: -16px">
            <ion-card-subtitle style="margin-top: 10px">{{ tool?.automation?.name ?? 'Automation' }}</ion-card-subtitle>
            <ion-button fill="clear" color="dark" (click)="removeAutomation(tool)">
              <ion-icon name="trash-outline"></ion-icon>
            </ion-button>
          </ion-card-header>
          <ion-card-content>
            <ion-list>
              <ion-item>
                <ion-label class="input-label">Tool</ion-label>
                <ion-button *ngIf="!tool.automationId" color="light" (click)="selectAutomation(tool)" slot="end">
                  <ion-icon name="flash-outline" class="padded-icon button-icon"></ion-icon>
                  Select an automation
                  <ion-icon name="chevron-down-outline" class="icon-padded-left button-icon"></ion-icon>
                </ion-button>
                <ion-button *ngIf="tool.automationId" color="light" (click)="selectAutomation(tool)" slot="end">
                  <ion-icon name="flash-outline" class="padded-icon button-icon"></ion-icon>
                  {{ tool?.automation?.name ?? 'Automation' }}
                </ion-button>
              </ion-item>

              <ion-item>
                <ion-label class="input-label">Description</ion-label>
                <ion-input [(ngModel)]="tool.description" slot="end"></ion-input>
              </ion-item>

              <ion-item>
                <ng-container>
                  <ion-label class="input-label">Approver</ion-label>
                  <ion-button *ngIf="tool.approverId" color="light" (click)="removeEntity(tool)" slot="end">
                    <ion-avatar class="user-photo">
                      <app-avatar size="25" [name]="tool.approver?.name" [image]="tool?.approver?.photo"></app-avatar>
                    </ion-avatar>
                    {{ tool.approver?.name }}
                    <ion-icon
                      name="close-circle-outline"
                      style="margin-left: 25px"
                      class="padded-icon button-icon"
                    ></ion-icon>
                  </ion-button>
                  <ion-button *ngIf="!tool.approverId" color="light" (click)="selectEntity(tool)" slot="end">
                    Select
                  </ion-button>
                </ng-container>
              </ion-item>
            </ion-list>
          </ion-card-content>
        </ion-card>
        <br />
        <ion-button (click)="addNewTool()" color="light" class="button-small">
          <ion-icon name="add"></ion-icon>
          Add new integration
        </ion-button>
        <hr />
      </ng-container>

      <ion-label class="input-label">Private Tickets Created via Bot DMs</ion-label>
      <div class="input-field" style="padding: 15px">
        <ng-container *ngIf="!authService.tenant.accountsEnabled">
          <ion-label class="input-label"> Default Customer </ion-label>
          <br />
          <ion-button *ngIf="!defaultCustomer?.name" fill="outline" (click)="selectCustomer()">
            <ion-icon name="business-outline" class="padded-icon button-icon"></ion-icon>
            Link to Customer:
            <ion-icon name="chevron-down-outline" class="icon-padded-left button-icon"></ion-icon>
          </ion-button>
          <ion-button *ngIf="defaultCustomer?.name" color="light" (click)="selectCustomer()">
            <ion-icon name="business" class="padded-icon button-icon"></ion-icon>
            {{ defaultCustomer.name }}
          </ion-button>
          <ion-button color="danger" fill="clear" (click)="unlinkCustomer()" *ngIf="defaultCustomer">
            Unlink
          </ion-button>
          <br />
          <br />
        </ng-container>
        <ion-label style="margin-top: 10px" class="input-label"> Share Ticket Details in Slack for Agents: </ion-label>
        <br />
        <app-channel-selector
          [channel]="defaultSlackChannel"
          (channelDidChange)="onSlackChannelChanged($event)"
          [defaultInternalOnly]="true"
          [initialButtonText]="'Default (Project-level triage channel)'"
        ></app-channel-selector>
      </div>
      <ion-label>
        <a href="https://docs.unthread.io/conversations/slack-bot" target="_blank">
          <ion-icon name="book-outline" class="padded-icon"></ion-icon>
          <span>Learn more about Bot DMs</span>
        </a>
      </ion-label>
    </div>
  </div>
</ion-content>

<ion-footer class="footer flex-space-between">
  <ion-button (click)="submit()" [disabled]="isLoading">
    Save
    <ion-spinner name="crescent" [hidden]="!isLoading" style="margin-left: 10px"></ion-spinner>
  </ion-button>
  <div>
    <ion-button
      fill="clear"
      color="dark"
      (click)="duplicate()"
      [disabled]="isLoading"
      *ngIf="id"
      ngxTippy
      data-tippy-content="Duplicate"
      style="margin-left: 10px"
    >
      <ion-icon name="duplicate-outline"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      color="dark"
      (click)="moveProject()"
      [disabled]="isLoading"
      *ngIf="id"
      ngxTippy
      data-tippy-content="Move project"
    >
      <ion-icon name="log-out-outline"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      color="dark"
      (click)="delete()"
      [disabled]="isLoading"
      *ngIf="id"
      ngxTippy
      data-tippy-content="Delete"
    >
      <ion-icon name="trash-outline"></ion-icon>
    </ion-button>
  </div>
</ion-footer>
